var _path, _path2, _g, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_286)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#2BA8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5341 82.5H8.7706V72.3182H12.5291C13.5665 72.3182 14.4598 72.522 15.2088 72.9297C15.9612 73.334 16.5412 73.9174 16.9489 74.6797C17.3565 75.4387 17.5604 76.3468 17.5604 77.4041C17.5604 78.4647 17.3565 79.3762 16.9489 80.1385C16.5445 80.9008 15.9661 81.4858 15.2138 81.8935C14.4614 82.2978 13.5682 82.5 12.5341 82.5ZM11.2315 80.402H12.4396C13.0097 80.402 13.492 80.3059 13.8864 80.1136C14.2841 79.9181 14.584 79.6016 14.7862 79.1641C14.9917 78.7232 15.0945 78.1366 15.0945 77.4041C15.0945 76.6716 14.9917 76.0883 14.7862 75.6541C14.5807 75.2166 14.2775 74.9018 13.8764 74.7095C13.4787 74.514 12.9882 74.4162 12.4048 74.4162H11.2315V80.402ZM28.6072 77.4091C28.6072 78.5294 28.3918 79.4789 27.9609 80.2578C27.5301 81.0367 26.9467 81.6283 26.2109 82.0327C25.4785 82.437 24.6565 82.6392 23.745 82.6392C22.8303 82.6392 22.0066 82.4354 21.2741 82.0277C20.5417 81.62 19.96 81.0284 19.5291 80.2528C19.1016 79.474 18.8878 78.526 18.8878 77.4091C18.8878 76.2888 19.1016 75.3393 19.5291 74.5604C19.96 73.7815 20.5417 73.1899 21.2741 72.7855C22.0066 72.3812 22.8303 72.179 23.745 72.179C24.6565 72.179 25.4785 72.3812 26.2109 72.7855C26.9467 73.1899 27.5301 73.7815 27.9609 74.5604C28.3918 75.3393 28.6072 76.2888 28.6072 77.4091ZM26.0916 77.4091C26.0916 76.7462 25.9972 76.1861 25.8082 75.7287C25.6226 75.2713 25.3542 74.925 25.0028 74.6896C24.6548 74.4543 24.2356 74.3366 23.745 74.3366C23.2578 74.3366 22.8385 74.4543 22.4872 74.6896C22.1359 74.925 21.8658 75.2713 21.6768 75.7287C21.4912 76.1861 21.3984 76.7462 21.3984 77.4091C21.3984 78.072 21.4912 78.6321 21.6768 79.0895C21.8658 79.5469 22.1359 79.8932 22.4872 80.1286C22.8385 80.3639 23.2578 80.4815 23.745 80.4815C24.2356 80.4815 24.6548 80.3639 25.0028 80.1286C25.3542 79.8932 25.6226 79.5469 25.8082 79.0895C25.9972 78.6321 26.0916 78.072 26.0916 77.4091ZM39.2862 76.0071H36.8004C36.7673 75.7519 36.6993 75.5215 36.5966 75.3161C36.4938 75.1106 36.358 74.9349 36.1889 74.7891C36.0199 74.6432 35.8194 74.5322 35.5874 74.456C35.3587 74.3764 35.1051 74.3366 34.8267 74.3366C34.3329 74.3366 33.907 74.4576 33.549 74.6996C33.1944 74.9415 32.9209 75.2912 32.7287 75.7486C32.5398 76.206 32.4453 76.7595 32.4453 77.4091C32.4453 78.0852 32.5414 78.652 32.7337 79.1094C32.9292 79.5634 33.2027 79.9065 33.554 80.1385C33.9086 80.3672 34.3279 80.4815 34.8118 80.4815C35.0836 80.4815 35.3305 80.4467 35.5526 80.3771C35.7779 80.3075 35.9751 80.2064 36.1442 80.0739C36.3165 79.938 36.4574 79.7739 36.5668 79.5817C36.6795 79.3861 36.7573 79.1657 36.8004 78.9205L39.2862 78.9354C39.2431 79.3861 39.1122 79.8303 38.8935 80.2678C38.678 80.7053 38.3814 81.1046 38.0036 81.4659C37.6257 81.8239 37.165 82.1089 36.6214 82.321C36.0812 82.5331 35.4614 82.6392 34.7621 82.6392C33.8407 82.6392 33.0154 82.437 32.2862 82.0327C31.5604 81.625 30.987 81.0317 30.5661 80.2528C30.1451 79.474 29.9347 78.526 29.9347 77.4091C29.9347 76.2888 30.1484 75.3393 30.576 74.5604C31.0036 73.7815 31.5819 73.1899 32.3111 72.7855C33.0402 72.3812 33.8572 72.179 34.7621 72.179C35.3786 72.179 35.9486 72.2652 36.4723 72.4375C36.996 72.6065 37.4567 72.8551 37.8544 73.1832C38.2521 73.508 38.5753 73.9074 38.8239 74.3814C39.0724 74.8554 39.2266 75.3973 39.2862 76.0071Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 16,
    height: 3,
    fill: "#2BA8C5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 36,
    width: 16,
    height: 3,
    fill: "#2BA8C5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 42,
    width: 35,
    height: 3,
    fill: "#2BA8C5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 48,
    width: 35,
    height: 3,
    fill: "#2BA8C5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 54,
    width: 35,
    height: 3,
    fill: "#2BA8C5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 60,
    width: 35,
    height: 3,
    fill: "#2BA8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoc);
export default __webpack_public_path__ + "static/media/ico_doc.d5e6a00f2b545e3751c8810d8c29e4e5.svg";
export { ForwardRef as ReactComponent };